import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import TargetBlankIcon from './TargetBlankIcon'
import { Link } from 'react-router-dom'
import styled from '@emotion/styled'
import { SidebarToggleContext } from 'portal-modules/common/utils/sidebar-provider'
import getProjectConditions from 'portal-modules/common/utils/get-project-conditions'
const { isRP } = getProjectConditions()

const StyledA = styled('a')`
  flex-direction: ${({ isMenuExpanded }) =>
    isMenuExpanded ? 'row' : 'column'};
  @media screen and (min-width: 1620px) and (max-width: 1920px) {
    color: ${({ theme }) =>
      isRP ? theme.reskinMenu.inactive_color : theme.text.dark};
  }
`
const StyledLink = styled(Link)`
  @media screen and (min-width: 1620px) and (max-width: 1920px) {
    color: ${({ theme }) =>
      isRP ? theme.reskinMenu.inactive_color : theme.text.dark};
  }
`

const ExternalLink = ({
  children,
  empty,
  reversed,
  size,
  linkTarget,
  noIcon = false,
  ...props
}) => {
  let Component = StyledA
  let updatedProps

  if (props?.href) {
    if (props?.href?.indexOf('/app/apartment/documents/custom-form/') != -1) {
      let customDoc = props?.href?.split(
        '/app/apartment/documents/custom-form/',
      )
      let newHref = '/app/apartment/documents/custom-form/' + customDoc[1]
      Component = StyledLink
      updatedProps = { to: newHref }
    } else {
      updatedProps = {
        href: props?.href,
        rel: 'noopener noreferrer',
        target: linkTarget,
      }
    }
  }

  const { isMenuExpanded } = useContext(SidebarToggleContext)
  return (
    <Component
      {...updatedProps}
      isMenuExpanded={isMenuExpanded}
      className={props?.className}
    >
      {children}{' '}
      {noIcon ? (
        <></>
      ) : (
        <TargetBlankIcon empty={empty} reversed={reversed} size={size} />
      )}
    </Component>
  )
}

ExternalLink.propTypes = {
  children: PropTypes.any,
  // for `TargetBlankIcon`
  empty: PropTypes.bool,
  // will use `href` or `to`
  href: PropTypes.string,
  // for `TargetBlankIcon`
  linkTarget: PropTypes.string,
  reversed: PropTypes.bool,
  // for `TargetBlankIcon`
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  // will use `href` or `to`
  to: PropTypes.string,
  noIcon: PropTypes.bool,
}

ExternalLink.defaultProps = {
  linkTarget: '_blank',
}

export default ExternalLink
